export const partDefault: Part = {
    available: true,
    colidx: 0,
    rowidx: 0,
    colcnt: 1,
    rowcnt: 1,
    comCode: '',
    component: '',
    enabled: true,
    fixedColcnt: 1,
    fixedRowcnt: 2,
    webpartId: '',
    isFixedSize: false,
    lock: false,
    templateId: '',
    title: '',
    titleEn: '',
    type: "part",
    props: {}
};


export type Parts = Part[]

export type Part = {} & PartDesigner & webpartv3.WebpartDesignData

export type PartDesigner = {
    /**
     * true: 디자이너 레이아웃에 추가 가능한 웹파트
     * false: 디자이너 레이아웃에 이미 추가되어 있는 상태, 웹파트 목록(PartChooser)에는 표시하지 않음.
     */
    available: boolean
    props?: { [key: string]: any }
}

export type PartData = {
    /**
     * 파트가 수정하지 못하도록 잠겨있는 상태인지 여부
     */
    lock: boolean
    /**
     * 파트 고유 아이디
     */
    id: number
} & PartContext

export type LayoutConfig = {
    cols: number
    rows: number
    rowHeight: number
    designWidth: number
    /**
     * 웹파트 템플릿 개인화를 위한 환경인지 여부
     * 개인화인 경우 일부 관리적 기능이 제한됨
     */
    personal: boolean
}

export type PartContext = {
    title: string
}

export type PartContexts = { [key: number]: PartContext }

export type Units = {
    width: number
    height: number
}

export type DraggingContext = {
    active: boolean
    /**
     * 드래깅 중 ESC 키를 눌러서 취소한 경우
     */
    cancelled: boolean
    id: string | number
    part: Part
}

export type DesignContext = {
    /**
     * 선택된 파트 아이템 식별자
     */
    selected: string | number
}

export type DragInfo = {
    part: Part
    event: DragEvent
    initialPos: InitialPos
}

export type InitialPos = {
    left: number
    top: number
    width: number
    height: number
}

export type Interact = {
    /**
     * 디자인 레이아웃에 배치된 파트를 이동하거나 리사이즈하는 경우, 해당 파트의 인스턴스를 가진다
     */
    part: Part
    /**
     * 파트 컨테이너를 마우스로 잡고 이동하고 있는 상태인지 여부
     */
    dragging: boolean
    /**
     * Design Layout 2차원 배열
     * ex) [[0,0,1,1],[1,0,0,0],[0,1,1,0]]
     * 1은 배치 가능한 영역
     * 0은 이미 파트가 영역에 할당되어 있음을 의미
     */
    grid: number[][] | null
    handler: (e: MouseEvent) => void
    /**
     * 인터렉트 대상 파트의 left 위치
     */
    left: number
    /**
     * 인터렉트 대상 파트의 top 위치
     */
    top: number
    /**
     * 인터렉트 대상 파트의 폭
     */
    width: number
    /**
     * 인터렉트 대상 파트의 높이
     */
    height: number
    /**
     * HTML 문서 기준 마우스 커서의 left 컬럼 위치
     */
    x0: number
    /**
     * HTML 문서 기준 마우스 커서의 top Row 위치
     */
    y0: number
    /**
     * 플레이스홀더의 예상 left 위치(px)
     */
    xu: number
    /**
     * 플레이스홀더의 예상 top 위치(px)
     */
    yu: number
}

export type WebpartMoveLayerOptions = {
    action: 'front' | 'forward' | 'back' | 'backward'
    part: Part
}
